export default (state = [], action) => {
  switch (action.type) {
    case 'LIST_CONVERSATION_MESSAGES':
      return [
        ...action.messages
      ];
      break;
    case 'NEW_MESSAGE':
      return [
        ...state,
        action.message
      ]
      break;
    case 'CLEAN_CONVERSATION':
      return [];
      break;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/conversation-messages.js